export const filters = {
  document: 'Document',
};

export const documentOptions = [
  { id: -1, name: 'All Documents' },
  { id: 'CNDC', name: 'Clear NDC' },
  { id: 'ONDC', name: 'NDC with Outstanding Indent' },
  { id: 'NO_DOCUMENT', name: 'Documents not available' },
];
